// TestDashboard.js (JavaScript) - Version: v1 i7

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "./BackButton";
import "./TestDashboard.css"; // Einheitliches Styling für Dashboards

export default function TestDashboard() {
    const [remainingDays, setRemainingDays] = useState(null);
    const navigate = useNavigate();
    const logo = "/logo192.png"; // Logo aus /public/-Ordner laden

    useEffect(() => {
        const role = localStorage.getItem("role");
        const token = localStorage.getItem("token");

        console.log("📌 TestDashboard geladen: Rolle =", role, "| Token =", token);

        if (role !== "test" || !token) {
            console.warn("⚠️ Kein Token oder falsche Rolle, leite zu Login um...");
            navigate("/login");
            return;
        }

        // JWT auslesen und verbleibende Tage abrufen
        fetch("https://freiseinapp.de/api/auth.php", {
            method: "POST",
            headers: { 
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        })
        .then(res => res.json())
        .then(data => {
            console.log("📌 API-Antwort TestDashboard:", data);
            if (data.verbleibendeTage !== undefined) {
                setRemainingDays(data.verbleibendeTage);
            } else {
                console.warn("⚠️ Keine verbleibenden Tage erhalten, Weiterleitung zu Login");
                navigate("/login");
            }
        })
        .catch(error => {
            console.error("❌ Fehler in TestDashboard:", error);
            navigate("/login");
        });
    }, [navigate]);

    return (
        <div className="dashboard-container">
            <div className="dashboard-box">
                <img src={logo} alt="FreiSeinApp Logo" className="dashboard-logo" />
                <h2>🕒 Dein Testzeitraum</h2>
                {remainingDays !== null ? (
                    remainingDays > 0 ? (
                        <p className="remaining-days">🎉 Du hast noch <strong>{remainingDays}</strong> Tage übrig.</p>
                    ) : (
                        <p className="expired">❌ Dein Testzeitraum ist abgelaufen.<br/> 
                        <a href="/abo" className="subscribe-link">Hier abonnieren.</a></p>
                    )
                ) : (
                    <p className="loading">⏳ Lade...</p>
                )}
                <BackButton />
            </div>
        </div>
    );
}
